import { useQuery } from "react-query";
import { orderMicroService } from "../services";

const replaceGuestUserCart = async (cartId: string, customerId: string) => {
  try {
    const response = await orderMicroService.replaceGuestUserCart({cartId, customerId})
    return response?.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    } else {
      return error.data;
    }
  }
};

export default function useReplaceGuestUserCart(cartId: string, customerId: string) {
  return useQuery<any>(["replaceGuestUserCart"], () => replaceGuestUserCart(cartId, customerId), {
    enabled: false,
  });
}